export default {"src":"/_next/static/media/not-found.c3c02498.svg","height":178,"width":106,"blurWidth":0,"blurHeight":0};